import { KameleoonGoalData } from '@/hooks/kameleoon/kameleoonGoals';
import { useTrackConversion } from '@/hooks/kameleoon/useTrackConversion';

export const useTrackItemSavedCatalogPage = () => useTrackConversion({ goal: KameleoonGoalData.SavedItemCatalogPage });
